import { Container } from '@pixi/display';
import gsap from 'gsap';
import LocalisedText from './LocalisedText';

export class RankTitleLabel extends Container
{
    private content: Container;
    private title: LocalisedText;
    private titleID: string;
    private tier: number;

    constructor()
    {
        super();
        
        this.titleID = "";
        this.tier = 0;

        this.content = new Container();
        this.addChild(this.content);

        this.title = new LocalisedText('', {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            align: 'left',
            fontSize: 31,
            stroke: 0x333333,
            strokeThickness: 10,
            lineJoin: 'round',
            maxWidth: 330
        });
        this.title.y = -1;
        this.title.anchor.set(0.5, 0.5);
        this.content.addChild(this.title);
    }

    public refresh(titleId: string, tier: number, animated = false): void
    {
        this.swapTitle(titleId, tier, animated);
    }

    private async swapTitle(titleId: string, tier: number, animated = false): Promise<void>
    {
        if (this.titleID === titleId && this.tier === tier) return;
        this.title.y = -1;
        this.titleID = titleId; 
        this.tier = tier;

        gsap.killTweensOf(this.title);
        if (!animated)
        {   
            this.title.setText(`rankTitle_${titleId}`, { tier });
        }
        else
        {
            await gsap.to(this.title, { y: -30, alpha: 0, duration: 0.1, ease: 'sine.out' });
            this.title.setText(`rankTitle_${titleId}`, { tier });
            this.title.y = 30;
            await gsap.to(this.title, { y: -1, alpha: 1, duration: 0.3, ease: 'back.out' });
        }
    }
}
